import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IMergeChallengeRequest } from './merge-challenge-request';
import type { IMergeChallengeResponse } from './merge-challenge-response';
import { mergeChallengeResponseSchema } from './merge-challenge-response';

export async function mergeChallengeApi({
  challengeId,
  destinationChallengeId,
}: IMergeChallengeRequest): Promise<IValidatedResponse<IMergeChallengeResponse>> {
  return postRequest<IMergeChallengeResponse>({
    path: `/sys/challenges/${challengeId}/merge`,
    body: { destinationChallengeId },
    schema: mergeChallengeResponseSchema,
  });
}
